export default __webpack_public_path__ + "static/media/E_wdt_c_cap_0.ed31fe33.mp3";